
import { defineComponent } from "vue";

export default defineComponent({
  name: "ExpenseCategoryForm",
  props: ["modelValue", "loading", "icon"],
  emits: ["submit", "update:modelValue"],
});
